<template>
  <svg
    id="_002-fullscreen"
    data-name="002-fullscreen"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 26.656 25.602"
  >
    <path
      id="Path_516"
      data-name="Path 516"
      d="M5.051,3.984H6.778a1.445,1.445,0,0,0,0-2.89H1.549a1.451,1.451,0,0,0-.27.027c-.043.009-.084.025-.126.038a1.383,1.383,0,0,0-.144.045,1.431,1.431,0,0,0-.137.072C.835,1.3.8,1.314.761,1.338a1.414,1.414,0,0,0-.216.177l0,0-.007.009c-.016.017-.029.037-.045.055A1.436,1.436,0,0,0,0,2.656V7.873a1.445,1.445,0,1,0,2.89,0V5.911l4.876,4.875A1.445,1.445,0,0,0,9.811,8.743Z"
      transform="translate(0 -1.094)"
      :fill="iconColor"
    />
    <path
      id="Path_517"
      data-name="Path 517"
      d="M7.767,33.668,2.89,38.545V36.584a1.445,1.445,0,0,0-2.89,0V41.8a1.435,1.435,0,0,0,.487,1.074,1.45,1.45,0,0,0,.274.244c.034.023.071.039.107.058a1.413,1.413,0,0,0,.142.074c.047.02.1.03.144.045s.082.028.125.037a1.437,1.437,0,0,0,.283.029H6.778a1.445,1.445,0,1,0,0-2.89H5.05l4.76-4.76a1.445,1.445,0,0,0-2.043-2.043Z"
      transform="translate(0 -17.759)"
      :fill="iconColor"
    />
    <path
      id="Path_518"
      data-name="Path 518"
      d="M42.884,35.139a1.445,1.445,0,0,0-1.445,1.445v1.961l-4.877-4.877a1.445,1.445,0,0,0-2.043,2.043l4.76,4.76H37.551a1.445,1.445,0,0,0,0,2.89h5.216a1.433,1.433,0,0,0,.283-.029,1.322,1.322,0,0,0,.129-.038,1.436,1.436,0,0,0,.141-.043,1.5,1.5,0,0,0,.148-.078c.033-.019.068-.033.1-.054A1.882,1.882,0,0,0,44.33,41.8V36.584A1.446,1.446,0,0,0,42.884,35.139Z"
      transform="translate(-17.674 -17.759)"
      :fill="iconColor"
    />
    <path
      id="Path_519"
      data-name="Path 519"
      d="M35.419,11.21a1.44,1.44,0,0,0,1.022-.423L41.318,5.91V7.872a1.445,1.445,0,0,0,2.89,0V2.655A1.436,1.436,0,0,0,43.72,1.58a1.447,1.447,0,0,0-.273-.244c-.033-.022-.069-.037-.1-.056A1.441,1.441,0,0,0,43.2,1.2a1.363,1.363,0,0,0-.143-.044c-.042-.013-.082-.029-.127-.038a1.429,1.429,0,0,0-.283-.028H37.429a1.445,1.445,0,0,0,0,2.89h1.728L34.4,8.743a1.446,1.446,0,0,0,1.022,2.467Z"
      transform="translate(-17.611 -1.093)"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '15',
    },
    width: {
      type: String,
      default: '15',
    },
    color: {
      type: String,
      default: 'primary-gray-700',
    },
  },
  computed: {
    iconColor() {
      return `var(--${this.color})`
    },
  },
}
</script>
